if (!customElements.get('atoto-halloween')) {
  customElements.define('atoto-halloween', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const onClick = async (event) => {
        const button = event.target.closest('[data-copy-code]');
        if (!button || !this.contains(button)) return;
        const code = button.dataset.copyCode;
        const status = this.querySelector('[data-copy-status]');
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(code);
          status.textContent = `Copied: ${code}`;
        } catch {
          status.textContent = `Your coupon code: ${code}`;
        }
        status.classList.add('is-visible');
        clearTimeout(this.toastTimer);
        this.toastTimer = setTimeout(() => status.classList.remove('is-visible'), 4000);
      };
      this.addEventListener('click', onClick);
      const links = [...this.querySelectorAll('.hw26-nav a')];
      const groups = [...this.querySelectorAll('.hw26-group')];
      const updateNavigation = () => {
        this.scrollFrame = null;
        const threshold = this.querySelector('.hw26-nav').getBoundingClientRect().bottom + 50;
        const current = groups.filter((group) => group.getBoundingClientRect().top <= threshold).pop() || groups[0];
        if (!current) return;
        links.forEach((link) => {
          if (link.hash === `#${current.id}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      const onScroll = () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(updateNavigation);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      updateNavigation();
      this.cleanup = () => {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.toastTimer);
        this.removeEventListener('click', onClick);
      };
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}
